import React, { useEffect } from "react";
import Confetti from "react-confetti";
import { Outlet } from "react-router-dom";
import { useImmer } from "use-immer";

import { Box } from "@mui/material";
import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";
import { ViewAs } from "@src/components/Navigation/ViewAs/ViewAs";
import { useDispatch, useSelector } from "@src/store";
import { IgPageContent } from "@src/utils/IgPageContent";

import { setConfetti } from "../store/slices/global";

import { AlertProvider } from "./AlertProvider";

export const StandardPageProvider = () => {
  const confetti = useSelector((state) => state.global.confetti);
  const dispatch = useDispatch();
  const [fadeOut, setFadeOut] = useImmer(false);

  // const snowflake1 = document.createElement("img");
  // snowflake1.src = snowflakeImg;
  //
  // const images = [snowflake1];

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    if (confetti) {
      setFadeOut(false);
      timeout = setTimeout(() => {
        setFadeOut(true);
        setTimeout(() => {
          dispatch(setConfetti(false));
        }, 2000);
      }, 5000);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [confetti, dispatch]);

  // for christmas lights
  // const hideLights = useMemo(() => Cookies.get("hideLights"), []);
  // useEffect(() => {
  //   window["hideLights"] = () => {
  //     Cookies.set("hideLights", "true", { expires: 365 });
  //     window.location.reload();
  //   };
  // }, []);

  return (
    <Box
      id={"standard-page-provider-box"}
      sx={{
        display: "flex",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "1600px",
      }}
    >
      {/*{hideLights ? null : (*/}
      {/*  <>*/}
      {/*    <ChristmasGarland position="-1435px" />*/}
      {/*    <ChristmasGarland position="-135px" />*/}
      {/*    <ChristmasGarland position="1165px" />*/}
      {/*  </>*/}
      {/*)}*/}
      <NavigationDrawer isUnauthorized={false} />
      {/*snowfall instead of confetti for winter */}
      {/*{confetti && (*/}
      {/*  <Snowfall*/}
      {/*    snowflakeCount={350}*/}
      {/*    images={images}*/}
      {/*    radius={[8, 23]}*/}
      {/*    speed={[2, 4.5]}*/}
      {/*    style={{*/}
      {/*      zIndex: 1000,*/}
      {/*      opacity: fadeOut ? 0 : 1,*/}
      {/*      transition: "opacity 2s ease-out",*/}
      {/*    }}*/}
      {/*  />*/}
      {/*)}*/}
      {confetti ? <Confetti gravity={0.15} recycle={false} /> : null}
      <IgPageContent>
        <AlertProvider />
        <Outlet />
      </IgPageContent>
    </Box>
  );
};
